<template>
  <div class="vue-wrapper">
    <form autocomplete="off" @submit.prevent="handleSearchSubmit" style="width:100%; display: inline-flex; margin-left: 0.75rem;">

      <fieldset style="margin: 0;">
        <div class="grid-x grid-padding-x">

          <div class="cell large-2">
            <div class="select-container" style="margin-bottom: inherit;">
              <select v-model="form.Avdelingsid" name="Avdelingsid">
                <option v-for="option in dropdowns.avdeling" :key="option.key" :value="option.key" :disabled="option.disabled">{{ option.val }}</option>
              </select>
              <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
            </div>
          </div>

          <TheAutoCompleteInput
            containerClassName="cell large-3"
            name="Auksjon"
            ref="auksjonInput"
            v-model.trim="form.Auksjon"
            :placeholder="'Velg auksjon'"
            :hideLabel="true"
            :onInputCallback="onAuksjonSearchInput"
            :onSelectCallback="onAuksjonSearchSelected"
            :debounce="750"
            :minquery="2"
            :disabled="isAuctionDisabled"
          >
            <div slot="item" slot-scope="props">
              <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
              <span v-if="props.item.Auksjon_dato">
                ({{ props.item.Auksjon_dato | avantidate }})
              </span>
            </div>
          </TheAutoCompleteInput>

          <div class="cell auto">
            <DateFromTillForm
              v-model="form.date"
              :labelFrom="'Dato f.o.m'"
              :labelTill="'Dato t.o.m'"
              :requiredFrom="isDisabledCode"
              :requiredTill="isDisabledCode"
              :disabledLabel="true"
            />
          </div>
          <div class="cell large-2">
            <button v-if="!isFormDisabled" class="button small primary disabled" style="padding: 0; margin: 0;">Søk</button>
            <button v-else type="submit" class="button small primary" style="padding: 0; margin: 0;">Søk</button>
          </div>
        </div>
      </fieldset>
    </form>

    <span class="divider"></span>

    <ul class="button-group">
      <li>
        <span title="Organiser kolonner" class="button-container has-popover" :class="{'popover-active': colPopoverActive}">
          <span class="button action small glyph glyph-only" @click="toggleColPopover()">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-table"></use></svg>
          </span>
          <span class="popover popover-has-header popover-has-footer sortable align-x-center align-y-bottom large">
            <div class="popover-header"><span class="title">Organiser kolonner</span></div>
            <div class="custom-scrollbar">
              <draggable tag="ul" handle=".handle" :value="selectedColumns" @change="onDragChange">
                <li v-for="(column, index) in selectedColumns" v-bind:key="index" :class="{'disabled': !column.selected, 'inactive': !column.selected}">
                  <TheSwitchInputPopoverDragable v-if="!column.readonly" v-model="column.selected" :label="column.name" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                </li>
              </draggable>
            </div>
            <div class="popover-footer">
              <span class="button primary transparent tiny" @click="resetColumns()">Tillbakestill</span>
              <span class="button primary tiny" @click="saveColumns()">Lagre</span>
            </div>
          </span>
        </span>
      </li>
      <li>
        <span title="Visningssvalg" class="button-container has-popover" id="table-thumbnails-popover" :class="{'popover-active': imgPopoverActive}">
          <span class="button action small glyph glyph-only" @click="toggleImgPopover()">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-image"></use></svg>
          </span>
          <span class="popover popover-has-header radio align-x-center align-y-bottom medium">
            <div class="popover-header"><span class="title">Visningssvalg</span></div>
            <ul>
              <li v-for="(imagesize, index) in selectedImageSizes" v-bind:key="imagesize.key" :class="{'active': imagesize.selected}">
                <a href="javascript:;" @click="saveImageSizes(index, imagesize.key)">
                  <span class="radio-glyph"></span>
                  <span class="radio-title">{{imagesize.name}}</span>
                </a>
              </li>
            </ul>
          </span>
        </span>
      </li>
    </ul>

    <a href="javascript:;" @click="exportCsv()" title="Eksporter CSV" class="button action small glyph glyph-only">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
    </a>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import draggable from 'vuedraggable'
import AuksjonService from '@/services/AuksjonService'
import InstillingerService from '@/services/InstillingerService'
import TheAutoCompleteInput from '../../../Inputs/TheAutoCompleteInput'
import DateFromTillForm from '@/components/Inputs/DateFromTillForm'

const swapArrayElements = function (array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0]
  return array
}

export default {
  name: 'TheTilslagsskjermbildeTopbar',
  components: {
    draggable,
    DateFromTillForm,
    TheAutoCompleteInput
  },
  data () {
    return {
      colPopoverActive: false,
      imgPopoverActive: false,
      selectedColumns: [],
      selectedImageSizes: [],
      dropdowns: {
        avdeling: [],
        auksjon: []
      },
      form: {
        Avdelingsid: null,
        Auksjon: null,
        date: {
          from: null,
          till: null
        }
      }
    }
  },
  created () {
    // Remove popover on click outside...
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.colPopoverActive = false
        vm.imgPopoverActive = false
      }
    })

    // Add our model for selected columns
    this.selectedColumns = this._.cloneDeep(this.columns)
    this.selectedImageSizes = this._.cloneDeep(this.imagesizes)

    this.fetchSettings()

    let reportSearchQuery = localStorage.reportSearchQuery ? JSON.parse(localStorage.reportSearchQuery) : {}
    if (reportSearchQuery.Avdelingsid || reportSearchQuery.Avdelingsid >= 0) {
      this.form.Avdelingsid = reportSearchQuery.Avdelingsid
    }

    if (reportSearchQuery.Auksjon) {
      this.form.Auksjon = reportSearchQuery.Auksjon
    }
  },
  computed: {
    imagesizes: function () {
      return this.$store.getters['tilslagsskjermbilde/imagesizes']
    },
    columns: function () {
      return this.$store.getters['tilslagsskjermbilde/columns']
    },
    isDisabledCode: function () {
      return !!this.form.date.from || !!this.form.date.till || this.hasAvdelingsId
    },
    isAuctionDisabled: function () {
      return this.form.Avdelingsid === '' || this.form.Avdelingsid === null
    },
    isFormDisabled: function () {
      return (!!this.form.Auksjon && this.hasAvdelingsId) || (!!this.form.date.from && !!this.form.date.till && this.hasAvdelingsId)
    },
    hasAvdelingsId: function () {
      return !(this.form.Avdelingsid === null || this.form.Avdelingsid === '' || this.form.Avdelingsid === undefined)
    }
  },
  watch: {
    'form.Avdelingsid': function (newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.$refs['auksjonInput'].reload()
      }
    }
  },
  methods: {
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.Avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      this.form.Auksjon = item ? item.Auksjon : null
    },
    // See: https://github.com/SortableJS/Vue.Draggable
    onDragChange: function (event) {
      if (event.moved) {
        let x = event.moved.oldIndex
        let y = event.moved.newIndex

        // Update array, move and shift down or up...
        if (x > y) {
          for (let i = x; i > y; --i) {
            this.selectedColumns = swapArrayElements(this.selectedColumns, i, i - 1)
          }
        } else {
          for (let i = x; i < y; ++i) {
            this.selectedColumns = swapArrayElements(this.selectedColumns, i, i + 1)
          }
        }
      }
    },
    saveColumns: function () {
      this.$store.dispatch('tilslagsskjermbilde/saveColumns', this.selectedColumns)
        .then(() => {
          this.selectedColumns = this._.cloneDeep(this.columns)
          this.colPopoverActive = false

          bus.$emit('tilslagsskjermbilde-after-column-update')
        })
    },
    resetColumns: function () {
      this.$store.dispatch('tilslagsskjermbilde/resetColumns')
        .then(() => {
          this.selectedColumns = this._.cloneDeep(this.columns)
          this.colPopoverActive = false

          bus.$emit('tilslagsskjermbilde-after-column-update')
        })
    },
    saveImageSizes: function (index, key) {
      this.selectedImageSizes.forEach(element => {
        this.$set(element, 'selected', element.key === key)
      })

      this.$store.dispatch('tilslagsskjermbilde/saveImageSizes', this.selectedImageSizes)
        .then(() => {
          this.selectedImageSizes = this._.cloneDeep(this.imagesizes)
          this.imgPopoverActive = false

          bus.$emit('tilslagsskjermbilde-after-column-update')
        })
    },
    toggleColPopover: function () {
      if (!this.colPopoverActive) {
        this.colPopoverActive = true
        this.imgPopoverActive = false
      } else {
        this.colPopoverActive = false
        this.imgPopoverActive = false
      }
    },
    toggleImgPopover: function () {
      if (!this.imgPopoverActive) {
        this.imgPopoverActive = true
        this.colPopoverActive = false
      } else {
        this.imgPopoverActive = false
        this.colPopoverActive = false
      }
    },
    handleSearchSubmit: function () {
      let reportSearchQuery = {
        'Avdelingsid': this.form.Avdelingsid,
        'Auksjon': this.form.Auksjon
      }

      localStorage.reportSearchQuery = JSON.stringify(reportSearchQuery)

      bus.$emit('tilslagsskjermbilde-start', {
        code: this.form.Auksjon,
        department: this.form.Avdelingsid,
        from: this.form.date.from,
        to: this.form.date.till
      })
    },
    exportCsv: function () {
      bus.$emit('tilslagsskjermbilde-export')
    },
    fetchSettings: function () {
      // Avdeling
      this.dropdowns.avdeling.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.dropdowns.avdeling = response.data
          this.dropdowns.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned avdeling fra innstillinger')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Tilslagsskjermbilde/TheTopbar.vue